import { call, put, takeLatest } from "redux-saga/effects";
import {
  addAdmissionFailure,
  addAdmissionSuccess,
  deleteAdmissionFailure,
  deleteAdmissionSuccess,
  fetchAdmissionFailure,
  fetchAdmissionPatientFailure,
  fetchAdmissionPatientSuccess,
  fetchAdmissionsFailure,
  fetchAdmissionsSuccess,
  fetchAdmissionSuccess,
  fetchAllAdmissionsFailure,
  fetchAllAdmissionsFailures,
  fetchAllAdmissionsSucces,
  fetchAllAdmissionsSuccess,
  fetchReportListFailure,
  fetchReportListSuccess,
  updateAdmissionFailure,
  updateAdmissionSuccess,
} from "./admissionsActions";
import {
  addAdmissionEffect,
  deleteAdmissionEffect,
  editAdmissionEffect,
  listAdmission,
  listAdmissionAll,
  listAdmissionEffect,
  listReportEffect,
  ViewAdmissionEffect,
  ViewAdmissionPatientEffect,
} from "./admissionsEffect";
import {
  ADD_ADMISSION_REQUEST,
  DELETE_ADMISSION_REQUEST,
  FETCH_ADMISSION_PATIENT_REQUEST,
  FETCH_ADMISSION_REQUEST,
  FETCH_ALL_LIST_ADMISSIONS_REQUEST,
  FETCH_ALLS_LIST_ADMISSIONS_REQUEST,
  FETCH_LIST_ADMISSIONS_REQUEST,
  FETCH_REPORT_LIST_ADMISSIONS_REQUEST,
  UPDATE_ADMISSION_REQUEST,
} from "./admissionsType";

function* fetchAdmissionsSaga(action) {
  try {
    const Admissions = yield call(listAdmissionEffect, action.payload);
    yield put(fetchAdmissionsSuccess(Admissions));
  } catch (error) {
    yield put(fetchAdmissionsFailure(error.message));
  }
}

function* fetchAllAdmissionsSaga(action) {
  try {
    const Admissions = yield call(listAdmission, action.payload);
    yield put(fetchAllAdmissionsSuccess(Admissions));
  } catch (error) {
    yield put(fetchAllAdmissionsFailure(error.message));
  }
}

function* fetchAllsAdmissionsSaga(action) {
  try {
    const Admissions = yield call(listAdmissionAll, action.payload);
    yield put(fetchAllAdmissionsSucces(Admissions));
  } catch (error) {
    yield put(fetchAllAdmissionsFailures(error.message));
  }
}
function* fetchReportSaga(action) {
  try {
    const Admissions = yield call(listReportEffect, action.payload);
    yield put(fetchReportListSuccess(Admissions));
  } catch (error) {
    yield put(fetchReportListFailure(error.message));
  }
}

function* fetchAdmissionSaga(action) {
  try {
    const Admission = yield call(
      ViewAdmissionEffect,
      action.payload.admissionId
    );

    const doctorData = Admission.data || Admission;
    yield put(fetchAdmissionSuccess(doctorData));
  } catch (error) {
    yield put(fetchAdmissionFailure(error.message));
  }
}
function* fetchAdmissionPatientSaga(action) {
  try {
    const Admission = yield call(
      ViewAdmissionPatientEffect,
      action.payload.admissionId
    );

    const doctorData = Admission.data || Admission;
    yield put(fetchAdmissionPatientSuccess(doctorData));
  } catch (error) {
    yield put(fetchAdmissionPatientFailure(error.message));
  }
}
function* addAdmissionSaga(action) {
  try {
    const newAdmission = yield call(
      addAdmissionEffect,
      action?.payload?.admissionData
    );
    yield put(addAdmissionSuccess(newAdmission));
  } catch (error) {
    yield put(addAdmissionFailure(error.message));
  }
}

function* updateAdmissionSaga(action) {
  try {
    const admissionData = action.payload;
    const updatedAdmission = yield call(
      editAdmissionEffect,
      admissionData.admissionId,
      admissionData
    );
    yield put(updateAdmissionSuccess(updatedAdmission));
  } catch (error) {
    yield put(updateAdmissionFailure(error.message));
  }
}

function* deleteAdmissionSaga(action) {
  try {
    yield call(deleteAdmissionEffect, action.payload.admissionId);
    yield put(deleteAdmissionSuccess(action.payload.AdmissionId));
  } catch (error) {
    yield put(deleteAdmissionFailure(error.message));
  }
}

export function* AdmissionSagas() {
  yield takeLatest(FETCH_LIST_ADMISSIONS_REQUEST, fetchAdmissionsSaga);
  yield takeLatest(FETCH_ADMISSION_REQUEST, fetchAdmissionSaga);
  yield takeLatest(ADD_ADMISSION_REQUEST, addAdmissionSaga);
  yield takeLatest(UPDATE_ADMISSION_REQUEST, updateAdmissionSaga);
  yield takeLatest(DELETE_ADMISSION_REQUEST, deleteAdmissionSaga);
  yield takeLatest(FETCH_ADMISSION_PATIENT_REQUEST, fetchAdmissionPatientSaga);
  yield takeLatest(FETCH_REPORT_LIST_ADMISSIONS_REQUEST, fetchReportSaga);
  yield takeLatest(FETCH_ALL_LIST_ADMISSIONS_REQUEST, fetchAllAdmissionsSaga);
  yield takeLatest(FETCH_ALLS_LIST_ADMISSIONS_REQUEST, fetchAllsAdmissionsSaga);
}
